function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import PropTypes from 'prop-types';
import React, { cloneElement, isValidElement, PureComponent } from 'react';
import AlignToText from '../AlignToText';
import Button from '../Button';
import Icon from '../Icon';
import classNames from '../utils/classNames';
/**
 * The OverlayHeader component is a support component for Overlay which allows the passing
 * of title.
 *
 * - [Design Spec](https://atlas.np.tools.playstation.net/design/7ca5464e-1b6b-48f4-81fa-36c7a00d69cf/2?bounds=-0.183,0.151,0.964,0.655)
 *
 * ## Related Components
 * - [Overlay](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Overlay)
 *
 * ## Usage
 *
 * ```jsx
 * <OverlayHeader>
 *   The Overlay Title
 * </OverlayHeader>
 * ```
 */

var OverlayHeader = /*#__PURE__*/function (_PureComponent) {
  _inherits(OverlayHeader, _PureComponent);

  var _super = _createSuper(OverlayHeader);

  function OverlayHeader() {
    _classCallCheck(this, OverlayHeader);

    return _super.apply(this, arguments);
  }

  _createClass(OverlayHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          closeLabel = _this$props.closeLabel,
          closeCtaClickTrack = _this$props.closeCtaClickTrack,
          children = _this$props.children,
          onClose = _this$props.onClose,
          closeCta = _this$props.closeCta,
          squished = _this$props.squished,
          qa = _this$props.qa;
      var cta;

      if (closeCta && /*#__PURE__*/isValidElement(closeCta)) {
        cta = /*#__PURE__*/cloneElement(closeCta, {
          qa: "".concat(qa, "#close"),
          variant: 'quick-action',
          onClick: function onClick() {
            var onClick = closeCta.props.onClick;

            if (typeof onClick === 'function') {
              onClick.apply(void 0, arguments);
            }

            onClose();
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "close"
        }));
      }
      /**
       * We don't want to use header tag here because screen reader will interepret this whole
       * section as banner landmark but this section is not a banner landmark. Changing it
       * from header tag to div tag will make this section becoming generic container instead.
       */


      return /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#title"),
        className: classNames('psw-overlay-header', 'psw-p-y-8', 'psw-fill-x', squished && 'psw-is-squished')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-section', 'psw-l-line-repel-top', className)
      }, /*#__PURE__*/React.createElement("h2", {
        className: classNames('psw-t-title-m', 'psw-t-truncate-2', 'psw-m-r-5'),
        id: id
      }, children), /*#__PURE__*/React.createElement(AlignToText, {
        fontStyle: "title-m"
      }, cta || /*#__PURE__*/React.createElement(Button, {
        ariaLabel: closeLabel,
        qa: "".concat(qa, "#close"),
        onClick: onClose,
        variant: "quick-action",
        trackClick: closeCtaClickTrack
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "close"
      })))));
    }
  }]);

  return OverlayHeader;
}(PureComponent);

OverlayHeader.getClassName = function (_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen,
      footer = _ref.footer;
  return {
    root: classNames('psw-overlay', 'psw-c-bg-0', 'psw-l-full-screen', {
      'psw-pointer-events-on': isOpen
    }, {
      'psw-with-footer': !!footer
    }, className)
  };
};

OverlayHeader.defaultProps = {
  id: '',
  qa: '',
  className: '',
  closeCta: null,
  closeLabel: '',
  closeCtaClickTrack: '',
  children: null,
  squished: false,
  onClose: function onClose() {}
};
OverlayHeader.propTypes = {
  /**
   * Unique id to allow associating the header title content with another element via
   * aria-describedby or aria-labelledby.
   */
  id: PropTypes.string,

  /**
   * The qa selector to set for the instance of the component
   */
  qa: PropTypes.string,

  /**
   * Add custom classes to the Overlay Header, main usage is to set the width of
   * the header to match the content or per the designs
   */
  className: PropTypes.string,

  /**
   * Slot to pass in Button component instead of setting the individual props on header.
   * When this prop is set the following props are ignored
   * - closeLabel
   * - onClose
   * - closeCtaClickTrack
   */
  closeCta: PropTypes.element,

  /**
   * Value to use for close button aria-label
   */
  closeLabel: PropTypes.string,

  /**
   * Value to use for close button trackClick
   */
  closeCtaClickTrack: PropTypes.string,

  /**
   * Reduces the header height in mobile
   */
  squished: PropTypes.bool,

  /**
   * Overlay content
   */
  children: PropTypes.node,

  /**
   * Event callback called when the Overlay is closed
   */
  onClose: PropTypes.func
};
export default OverlayHeader;